<cerrix-loader [cerrixTab]="tab"></cerrix-loader>
@if (initReady) {
    @if (permissions.canView) {
        <auditor-audit-details
            [cerrixTab]="tab"
            [permissions]="permissions"
            [formGroup]="formGroup"
            [auditModel]="auditModel"
            [standingData]="standingData"
            [isSaved$]="isSaved$"
            (onSave)="save()"
        ></auditor-audit-details>
    }
    @if (permissions.canViewLimited) {
        <auditee-audit-details
            [cerrixTab]="tab"
            [permissions]="permissions"
            [formGroup]="formGroup"
            [auditModel]="auditModel"
            [standingData]="standingData"
            (onSave)="save()"
        ></auditee-audit-details>
    }
}
